import http from '@/request/http'

//答题记录
export function getRecordQuestionList(params) {
    const data = params;
    return http({
      url: "/api/v1/question/getRecordQuestionList",
      method: "post",
      data,
    });
  }
//答题记录  删除一个
export function delUserCateQuestionLog(params) {
    const data = params;
    return http({
      url: "/api/v1/question/delUserCateQuestionLog",
      method: "post",
      data,
    });
  }
  //答题记录  删除所有
  export function delAllUserCateQuestionLog(params) {
    const data = params;
    return http({
      url: "/api/v1/question/delAllUserCateQuestionLog",
      method: "post",
      data,
    });
  }
  
//发送题目记录
export function questionRecord(params) {
    const data = params;
    return http({
      url: "/api/v1/question/questionRecord",
      method: "post",
      data,
    });
  }

  
  

//考试
export function getPaperList(params) {
    const data = params
    return http({
        url: '/api/v1/paper/getPaperByCate',
        method: 'post',
        data
    })
}

//获取所有分类
export function getPaperCate(params) {
    const data = params
    return http({
        url: '/api/v1/cate/getCate',
        method: 'post',
        data
    })
}

//分类下所有问题
export function getQuestionListByCate(params) {
    const data = params
    return http({
        url: '/api/v1/question/getQuestionListByCate',
        method: 'post',
        data
    })
}

//用户加入考试
export function addPaper(params) {
    const data = params
    return http({
        url: '/api/v1/paper/addExmainPaper',
        method: 'post',
        data
    })
}

//获取考卷信息
export function getPaperDetail(params) {
    const data = params
    return http({
        url: '/api/v1/paper/getPaperQuestionBayId',
        method: 'post',
        data
    })
}

//判断某一道题是不是答对
export function getQuestionResult(params) {
    const data = params
    return http({
        url: '/api/v1/question/getJudegeQuestionAnswer',
        method: 'post',
        data
    })
}

//试卷提交
export function submitPaper(params) {
    const data = params
    return http({
        url: '/api/v1/paper/markPapers',
        method: 'post',
        data
    })
}

//查看试卷得分
export function getScore(params) {
    const data = params
    return http({
        url: '/api/v1/paper/getPaperScoreByPaperId',
        method: 'post',
        data
    })
}

//查看试卷情况
export function getScoreDetail(params) {
    const data = params
    return http({
        url: '/api/v1/paper/getQuestionByPaperForUserId',
        method: 'post',
        data
    })
}

//获取用户收藏列表
export function getCollectionList(params) {
    const data = params
    return http({
        url: '/api/v1/question/getCollectQuestionList',
        method: 'post',
        data
    })
}

//用户添加收藏
export function addCollection(params) {
    const data = params
    return http({
        url: '/api/v1/question/collectQuestion',
        method: 'post',
        data
    })
}

//用户取消收藏
export function deleteCollection(params) {
    const data = params
    return http({
        url: '/api/v1/question/uncollectQuestion',
        method: 'post',
        data
    })
}

//清空所有收藏
export function clearCollection(params) {
    const data = params
    return http({
        url: '/api/v1/question/uncollectQuestionAll',
        method: 'post',
        data
    })
}

//判断用户是否收藏
export function hasCollect(params) {
    const data = params
    return http({
        url: '/api/v1/question/isCollectQuestion',
        method: 'post',
        data
    })
}

//我的所有错题
export function getMistakeList(params) {
    const data = params
    return http({
        url: '/api/v1/question/getMyquestion',
        method: 'post',
        data
    })
}

//删除错题
export function deleteMistake(params) {
    const data = params
    return http({
        url: '/api/v1/question/delQuestion',
        method: 'post',
        data
    })
}

//清空错题
export function clearMistake(params) {
    const data = params
    return http({
        url: '/api/v1/question/delAllQuestion',
        method: 'post',
        data
    })
}

//我的练习列表
export function getPracticeList(params) {
    const data = params
    return http({
        url: '/api/v1/paper/myAllExmainPaperByUserId',
        method: 'post',
        data
    })
}

//删除练习
export function deletePractice(params) {
    const data = params
    return http({
        url: '/api/v1/paper/delPaper',
        method: 'post',
        data
    })
}

//清空练习
export function clearPractice(params) {
    const data = params
    return http({
        url: '/api/v1/paper/delAllPaper',
        method: 'post',
        data
    })
}